import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLayout = defineStore('layout', () => ({
  displayFooter: ref(true),
  displayHeader: ref(true),
}));
